import { getToken,axiosInstance } from "../utils/Api";
export const getLogs = async (data) =>{ 
    try {
        const response = await axiosInstance.get("/admin/logs/logsFiles",{
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
            data : data ,
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  }

  export const runRawQuery = async (data) =>{ 
    try {
        const response = await axiosInstance.post(`/admin/rawquery`,data,{ 
            headers: { Authorization: `Bearer ${getToken()}`},
        });
        return response.data;
    } catch (error) {
        throw error;
    } 
}

export const logContent = async (fileName) =>{ 
    try {
        const response = await axiosInstance.get(`/admin/logs/logfiles/${fileName}`,{
            headers: { Authorization: `Bearer ${getToken()}`}
        });
        return response.data;
    } catch (error) {
        throw error;
    } 
}
